import { render, staticRenderFns } from "./ClubChats.vue?vue&type=template&id=acf6f0b0&scoped=true"
import script from "./ClubChats.vue?vue&type=script&lang=js"
export * from "./ClubChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf6f0b0",
  null
  
)

export default component.exports